<template>
    <div class="container">
        <b-button v-if="!hideFilterButton" v-b-toggle.collapse-1 variant="primary" size="sm" class="mb-2">
            <b-icon icon="funnel"></b-icon> Bộ lọc
        </b-button>
        <b-collapse v-if="!hideFilterButton" id="collapse-1" class="mt-2">
            <b-card>
                <div class="row">
                    <div v-for="(filter, filterIndex) in filters" :class="filterClass" v-bind:key="columns[filter.col].name">
                        <label class="text-bold">{{columns[filter.col].alias}}</label>
                        

                        <template v-if="filter.type=='text'">
                            
                            <b-form-input type="text" v-model="filter.value" :placeholder="columns[filter.col].alias"/>
                            <a @click="filter.value=''" size="sm" variant="danger" class="delete-btn">xoá</a>
                        </template>

                        <template v-if="filter.type=='typeahead' && columns[filter.col].options && columns[filter.col].optionLabel"  >

                            <vue-bootstrap-typeahead 
                                v-model="filter.value"
                                :minMatchingChars="1"
                                :data="columns[filter.col].options"
                                :serializer="columns[filter.col].optionLabel"
                                @hit="filter.value = $event[columns[filter.col].optionValueName]"
                                /> 
                            <a @click="filter.value=''" size="sm" variant="danger" class="delete-btn">xoá</a>
                        </template>

                        <template v-if="filter.type=='widget-client-name'">
                            <client-widget @hit="widgetClientNameUpdated($event, filterIndex)"/>

                            <!-- <vue-bootstrap-typeahead 
                                v-model="filter.value"
                                :minMatchingChars="1"
                                :data="columns[filter.col].options"
                                :serializer="columns[filter.col].optionLabel"
                                @hit="filter.value = $event[columns[filter.col].optionValueName]"
                                />  -->
                            <!-- <a @click="filter.value=''" size="sm" variant="danger" class="delete-btn">xoá</a> -->
                        </template>

                        <template v-if="filter.type=='select' && columns[filter.col].options && !columns[filter.col].optionLabel">


                            <b-form-select v-model="filter.value" :options="columns[filter.col].options"></b-form-select>
                            <a @click="filter.value=''" size="sm" variant="danger" class="delete-btn">xoá</a>
                        </template>

                        <template v-if="filter.type=='multi-select'" >
               
                            <multiselect 
                                v-model="filter.value" 
                                v-if="filter.options"

                                :close-on-select="false"
                                :multiple="true"
                                track-by="value"
                                label="label"
                                :options="filter.options || columns[filter.col].options"
                                :placeholder="columns[filter.col].alias"
                                >
                                </multiselect>

                            <multiselect 
                                v-model="filter.value" 
                                v-if="!filter.options"

                                :close-on-select="false"
                                :multiple="true"
                                :options="columns[filter.col].options"
                                :placeholder="columns[filter.col].alias">
                                </multiselect>
                            <a @click="filter.value=''" size="sm" variant="danger" class="delete-btn">xoá</a>
                        </template>
                        

                        <template v-if="filter.type=='number'">
                            <div class="container row">
                                <b-form-input type="number" v-model="filter.from" placeholder="Cận dưới" class="col-5"/>
                                <b-form-input type="number" v-model="filter.to" placeholder="Cận trên" class="col-5"/>
                            </div>
                            <a @click="filter.from='';filter.to=''" size="sm" variant="danger" class="delete-btn">xoá</a>

                        </template>

                        <template v-if="filter.type=='checkbox'">

                            <b-form-checkbox
                                v-model="filter.value"
                                value="true"
                                unchecked-value="false"
                                >
                                {{columns[filter.col].alias}}
                                </b-form-checkbox>
                        </template>

                        <template v-if="filter.type=='boolean'">

                            <b-form-checkbox
                                v-model="filter.value"
                                value="true"
                                unchecked-value="false"
                                >
                                </b-form-checkbox>
                        </template>

                        <template v-if="filter.type=='checkbox_special'">

                            <b-form-checkbox
                                v-model="filter.value"
                                value="true"
                                unchecked-value="false"
                                >
                                </b-form-checkbox>
                        </template>

                    </div>
                    
                </div>

                <div class="row">
                    <b-button type="submit" variant="primary" @click="filterData()" class="mt-3">Tìm kiếm</b-button>
                </div>
            </b-card>
        </b-collapse>
            
        
         <CRow class="mt-2">
            <div class="d-flex justify-content-between align-items-center flex-wrap">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="pagination.total"
                    :per-page="pagination.limit"
                    :limit="5"
                    size="sm"
                    aria-controls="my-table"
                    class="mb-2"
                    ></b-pagination>

                <span class="text-muted">Số lượng: {{pagination.total}}</span>
            </div>
        </CRow>

        <CRow v-if="groupEditable">
            <b-dropdown text="Cập nhật đồng loạt" variant="success">
                <b-dropdown-item @click="updateGroupClicked(menu_item.code)" v-for="menu_item in menu" :key="menu_item.code">
                                {{menu_item.text}}
                            </b-dropdown-item>
                <b-dropdown-item @click="deleteGroupClicked()">Xóa</b-dropdown-item>
            </b-dropdown>
        </CRow>

        <CRow v-if="hasGroupForm">
            <b-dropdown text="Cập nhật đồng loạt" variant="success">
                <b-dropdown-item @click="openFormGroupModal()">Chỉnh sửa</b-dropdown-item>
                <b-dropdown-item @click="deleteGroupClicked()">Xóa</b-dropdown-item>
            </b-dropdown>
        </CRow>

        <CRow>
            <!-- <b-card class="col-12"> -->
            <b-table :items="data" 
                :fields="fields" 
                :busy="isLoading" 
                :responsive="true"
                sticky-header
                head-variant="dark"
                striped outlined bordered small
                class="responsive-table" >

                <template v-slot:cell(id)="data">
                    
                    <b-button @click="rowClicked(data.item.id)" class="pointer" size="sm" variant="primary" v-if="!menu">Xem</b-button>

                    <div v-if="itemEditable">
                        <b-icon v-if="groupEditable || hasGroupForm" :icon="data.item.checked ? 'check-square-fill' : 'square'" @click="data.item.checked = !data.item.checked" font-scale="1.8" class="ml-1 clickable"></b-icon>
                        <b-icon icon="pencil-square" font-scale="2" @click="rowEditClicked(data.item.id)" class="ml-1 my-2 clickable"></b-icon>
                    </div>

                    <b-dropdown id="dropdown-1" text="..." class="m-md-2" v-if="Array.isArray(menu) && menu.length > 0">
                        <b-dropdown-item @click="rowClicked(data.item.id)" v-if="viewMenuItemDetail">Xem chi tiết</b-dropdown-item>
                        <b-dropdown-item @click="rowDeleteClicked(data.item.id)" v-if="viewMenuItemDelete">Xóa</b-dropdown-item>
                        <b-dropdown-item @click="menuClicked(menu_item.code, data.item.id)" v-for="menu_item in menu" :key="menu_item.code">
                            {{menu_item.text}}
                        </b-dropdown-item>
                    </b-dropdown>

                    <div v-if="hasStars">
                        <b-icon :icon="data.item.isfavored ? 'star-fill' : 'star'" @click="updateStar(data.item.id, data.item.isfavored)" font-scale="1.8" class="ml-1 clickable"></b-icon>
                    </div>
                    <div class="mt-1">
                        <div v-if="hasPreview" style="display:inline-block">
                            <b-icon icon="eye" @click="rowPreviewClicked(data.item.id)" font-scale="1.6" class="m-1 clickable"></b-icon>
                        </div>
                        <div v-if="hasQuickForm" style="display:inline-block">
                            <b-icon icon="book" @click="rowQuickFormClicked(data.item.id)" font-scale="1.6" class="m-1 clickable"></b-icon>
                        </div>
                    </div>
                </template>

                <template v-slot:cell(image)="data">
                  <b-img width="40" :src="data.value" fluid alt="-" v-if="data.value"></b-img>
                    
                </template>

                <!-- <template v-slot:cell(code)="data">
                  <span>{{ data.value}}</span>

                    <b-button size="sm" class="mb-2" v-if="data.value != ''" @click="copyToClipboard(data.value)">
                        Copy
                    </b-button>
                    
                </template> -->

                <template v-slot:cell(gps)="data">
                  <span>{{ data.value}}</span>

                    <b-button size="sm" class="mb-2" v-if="data.value != ''" @click="gotoMap(data.value)">
                        <b-icon icon="map" aria-hidden="true"></b-icon>
                    </b-button>

                    <b-button size="sm" class="mb-2" v-if="data.value != ''" @click="copyToClipboard(data.value)">
                        Copy
                    </b-button>
                    
                </template>

                <template v-slot:cell(code)="data">
                    <span>{{ data.value}}</span>
                    <br/>
                    <b-button size="sm" class="mb-2" v-if="data.value != ''" @click="copyToClipboard(data.value)">
                        Copy
                    </b-button>
                </template>

                <template v-slot:cell(content)="data">
                   <!-- <span v-html="data.value"></span> -->
                   <div class="preserve-whitespace">{{ data.value }}</div>

                   <br/>
                    <b-button size="sm" class="mb-2" v-if="data.value != ''" @click="copyToClipboard(data.value)">
                        Copy
                    </b-button>
                </template>

                <template v-slot:cell(content_img_url)="data">
                  <a :href="data.value" v-if="data.value != ''" target="_blank">link</a>

                </template>

                <template v-slot:cell(product_url)="data">
                  <a :href="data.value" v-if="data.value != ''" target="_blank">link</a>

                </template>

                <template v-slot:cell()="data">
                  <span v-html="data.value"></span>

                </template>

                <template v-slot:table-busy>
                    <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                    </div>
                </template>
            </b-table>
            <!-- </b-card> -->
        </CRow>

        <CRow>
            <div class="d-flex justify-content-between align-items-center flex-wrap">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="pagination.total"
                    :per-page="pagination.limit"
                    :limit="5"
                    size="sm"
                    aria-controls="my-table"
                    class="mb-2"
                    ></b-pagination>

                <span class="text-muted">Số lượng: {{pagination.total}}</span>
            </div>
        </CRow>

        <div v-if="hasPreview">
            <b-modal v-model="previewModalShow" hide-footer title="Xem Nhanh">

                <generic-detail-view
                    :rootPath="'/v2/' + modalInfo.module"
                    :forms="modalInfo.forms"
                    :columns="modalInfo.columns"
                    :table_name="modalInfo.table_name"
                    :service="modalInfo.service"
                    :modalClientId="itemId"
                    layout="grid"
                    >
                </generic-detail-view>
    
                <!-- custom component -->
                <slot name="preview"></slot>

            </b-modal>
        </div>

        <div v-if="hasQuickForm">
            <b-modal size="lg" v-model="quickFormModalShow" hide-footer title="Nhập Nhanh">
            
                <!-- custom component -->
                <slot name="quickForm"></slot>

            </b-modal>
        </div>

        <div v-if="hasGroupForm">
            <b-modal v-model="modalShow" hide-footer title="Cập nhật đồng loạt">
                <generic-group-form-view
                    :forms="modalFormData.forms"
                    :columns="modalFormData.columns"
                    :table_name="modalFormData.table_name"
                    :ids="checkedIds"
                    @on-update-form-submitted="onUpdateFormSubmitted"
                    >
                </generic-group-form-view>
            </b-modal>
        </div>
    </div>
</template>

<script>
import GenericDetailView from '@/views/base/GenericDetailView'
import GenericGroupFormView from '@/views/base/GenericGroupFormView'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Multiselect from 'vue-multiselect'

import ClientWidget from '@/module-client/ClientWidget'

import Constants from '@/constants'
import axios from 'axios'
import moment from 'moment'
import Authorization from '@/module-authorization/Authorization'

export default {
  name: 'GenericTableView',
  components: {
    GenericDetailView,
    GenericGroupFormView,
    VueBootstrapTypeahead,
    Multiselect,
    'client-widget': ClientWidget
    },
  props: [
      'filters',
      'restrict_filters', // if the default filter has no value, we will use the restricted filter value
      'columns',
      'sorts',
      'table_name',
      'display_columns',
      'rowPreprocessFunc',
      'menu',
      'module_name',
      'groupEditable',
      'itemEditable',
      'viewMenuItemDetail',
      'viewMenuItemDelete',
      'hasStars',
      'hasPreview',
      'hasQuickForm',
      'modalInfo',
      'hasGroupForm',
      'modalFormData',
      'hideFilterButton', // hide the built-in filter button and collapse
  ],
  computed: {
    role() {
      console.log('GenericTableView::role::trying to get user role: ', this.$store.state.userRole)
      if (this.$store.state.userRole) {
        return this.$store.state.userRole;
      }

      return 'ctv'; // default role
    },

    email() {
      console.log('GenericTableView::email::trying to get user email: ', this.$store.state.userEmail)
      if (this.$store.state.userEmail) {
        return this.$store.state.userEmail;
      }

      return ''; // empty
    }
  },
  data () {
    return {
        isLoading: false,
        data: [],
        filterClass: 'col-xl-3 col-lg-4 col-md-6 col-sm-12 pl-1 mt-2',
        url: '',
        fields: [],

        currentPage: 1,
        created_by: '',

        pagination: {
            current: 1,
            total: 0,
            offset: 0,
            limit: 20
        },

        modalShow: false,
        previewModalShow: false,
        quickFormModalShow:false,
        itemId: null,
        checkedIds: [],
    }
  },
  watch: {
    currentPage: function (newPage, oldPage) {
    //   console.log('pageChanged');
      this.pagination.offset = (newPage-1) * this.pagination.limit;
      this.refreshData(false);
    },

    email: function(newEmail, oldEmail) {
      if (newEmail.length > 0) {
        this.refreshData(true);
      }
    }
  },
  methods: {
      widgetClientNameUpdated(client, filterIndex) {
          if(client) {
              console.log('client selected, ', client);

            this.filters[filterIndex].value = client['fullname'];
            console.log('filter updated: ', this.filters);
          }
          else {
              this.filters[filterIndex].value = '';
          }
      },

      generateTableViews () {
        this.fields = [];
        for(var i=0; i< this.display_columns.length; i++) {
            var col = this.display_columns[i];
            var f = null;
            var colMeta = {};

            if(typeof col === "string") {
                f = this.columns[col];
            }
            else {
                f = this.columns[col.key];
                colMeta['variant'] = col.variant;
            }

            if(!f) {
                // this is a virtual column
                colMeta['key'] = col.name;

                this.fields.push(colMeta);
            }
            else {
                colMeta['key'] = f.name;
                colMeta['label'] = f.alias;

                if(f.formatter) {
                    colMeta.formatter = f.formatter;
                }

                if(f.width) {
                    colMeta['style'] = `{ width: ${f.width}px }`
                }

                this.fields.push(colMeta);
            }
        }
      },

    convertFilterValueToWhereCondition(type, col, value, value_from, value_to, add_condition, text_search_type) {
        console.log('convertFilterValueToWhereCondition ', type, col, value, value_from, value_to, add_condition, text_search_type);

        var condition = null;

        // Helper function to check if a value is meaningful (not null, empty string, or empty array)
        var isMeaningfulValue = function(val) {
            if (val === null || val === undefined) return false;
            if (typeof val === 'string' && val.trim() === '') return false;
            if (Array.isArray(val) && val.length === 0) return false;
            return true;
        };

        if(type == 'text' && isMeaningfulValue(value)) {
            condition = 'UPPER(' + col + ") LIKE UPPER('%" + value + "%')"
        }
        else if(type == 'select' && isMeaningfulValue(value)) {
            condition = col + " = '" + value + "'"
        }
        else if(type == 'multi-select' && isMeaningfulValue(value) && value.length > 0) {
            var conditionString = "(";

            var arr = [];
            for(var j=0; j<value.length; j++) {
                if(text_search_type && text_search_type == 'fuzzy') {
                    arr.push(col + " LIKE '%" + value[j] + "%'");
                }
                else {
                    arr.push(col + " = '" + value[j] + "'");
                }
            }

            conditionString += arr.join(' OR ');

            conditionString += ")";
            condition = conditionString
        }
        else if(type == 'number') {
            var arr = [];

            if(isMeaningfulValue(value_from)) {
                arr.push(col + " >= " + value_from);
            }
            
            if(isMeaningfulValue(value_to)) {
                arr.push(col + " <= " + value_to);
            }

            if (arr.length == 1)
                condition = arr[0];
            else if (arr.length == 2)
                condition = '(' + arr[0] + ' AND ' + arr[1] + ')';

        }
        else if(type == 'boolean' && isMeaningfulValue(value)) {
            if (value =='true')
                condition = col + " = " + value;
        }
        else if(type == 'checkbox_special' && isMeaningfulValue(value)) {
            console.log(">>>>>>>", add_condition);

            if (value =='true')
                condition = add_condition;
        }
        else if (isMeaningfulValue(value)) {
            condition = col + " = '" + value + "'"
        }

        return condition;
    },

    getFilterValueFromName(col) {
        var retval = null;

        for(var i = 0; i<this.filters.length; i++) {
            var m = this.filters[i];

            if(m && m.col === col)
            {
                retval = m;
                break;
            }
        }

        return retval;
    },

    convertFilterArrayToFilterMap(filter_arr) {
        if(!filter_arr)
            return {};

        var restrict_filters_map = {};
        for(var j=0; j<filter_arr.length; j++) {
            var col = filter_arr[j].col;
            restrict_filters_map[col] = filter_arr[j];
        }

        return restrict_filters_map;
    },

    generateWhereConditions () {
        var restrict_filters_map = this.convertFilterArrayToFilterMap(this.restrict_filters);

        var where_conditions = [];
        for(var i = 0; i<this.filters.length; i++) {
            var m = this.filters[i];
            console.log('this.filters = ', this.filters);

            var col = m.col;
            var value = m.value;

            if(restrict_filters_map[col] && restrict_filters_map[col].value) {
                // if we have the restricted filter provided
                // we should give priority to the value provided
                value = restrict_filters_map[col].value;
            }

            var cond = this.convertFilterValueToWhereCondition(m.type, m.col, value, m.from, m.to, m.condition, m.text_search_type);
            if(cond) {
                console.log('convertFilterValueToWhereCondition: ', m.col, ':', cond);
                where_conditions.push(cond);
                console.log('Added condition for', m.col, ':', cond);
            } else {
                console.log('Skipped condition for', m.col, 'because value is not meaningful:', value);
            }
        }

        if(this.restrict_filters) {
            for(var j=0; j<this.restrict_filters.length; j++) {
                // we loop through the restrict filter
                // if the current filter value with the same name doesn't have value
                // then we'll use the restrict filter
                var col = this.restrict_filters[j].col;
                var restricted_value = this.restrict_filters[j].value;

                var foundFilter = false;
                for(var i=0; i<this.filters.length; i++) {
                    if(this.filters[i].col == col 
                    && this.filters[i].value
                    ) {
                        foundFilter = true;
                    }
                }

                if(!foundFilter) {
                    if(restricted_value) {
                        var f = this.getFilterValueFromName(col);
                        if(f) {
                            var cond = this.convertFilterValueToWhereCondition(f.type, f.col, restricted_value, null, null, null);
                            where_conditions.push(cond);
                        }
                    }
                    else {
                        where_conditions.push(col + ' is not null');
                    }
                    
                }
            }
        }
        

        var authorizeService = new Authorization();

        // append the created_by so that we will show user only the data they created
        console.log('GenericTableView::generateWhereConditions::authorization check:', {
            role: this.role,
            module_name: this.module_name,
            email: this.email,
            shouldFilter: authorizeService.shouldFilterDataByUser(this.role, this.module_name, this.email)
        });
        
        if(authorizeService.shouldFilterDataByUser(this.role, this.module_name, this.email)) {
            where_conditions.push("created_by = '" + this.email + "'");
        }

        return where_conditions;
    },

    generateOrderConditions () {
        var order_conditions = [];
        for(var key in this.sorts) {

            order_conditions.push(key+ ' ' + this.sorts[key]);
        }
        return order_conditions;
    },

    generatePaginationString () {
        var s = '';
        s += ' LIMIT ' + this.pagination.limit;
        s += ' OFFSET ' + this.pagination.offset;
        return s;
    },

    generateCountQuery () {
        var query = '';
        query += 'SELECT count(*) AS count';
        query += ' FROM ' + this.table_name + ' AS t'; // for check_special filter

        // generate where
        var where_conditions = this.generateWhereConditions();
        if(where_conditions.length>0){
            query += ' WHERE ' + where_conditions.join(' AND ');
        }

        query += ';';

        return query;
    },

    generateQuery: function() {
        var query = '';
        query += 'SELECT ';

        var select_columns = [];
        console.log('display_columns: ', this.display_columns);
        for(var i=0; i< this.display_columns.length; i++) {
            var col = this.display_columns[i];

            if(typeof col === "string") {
                select_columns.push(col);
            }
            else {
                if(col.is_virtual) {
                    // skip virtual column
                }
                else {
                    select_columns.push(col.key);
                }
            }
        }

        query += select_columns.join(',');
        query += ' FROM ' + this.table_name + ' AS t'; // for check_special filter

        // generate where
        var where_conditions = this.generateWhereConditions();
        if(where_conditions.length>0){
            query += ' WHERE ' + where_conditions.join(' AND ');
        }

        var orderConditions = this.generateOrderConditions();
        if(orderConditions.length > 0) {
            query += ' ORDER BY ' + orderConditions.join(',');
        }

        query += this.generatePaginationString();
        query += ';';

        return query;
    },

    filterData () {
        this.pagination.offset = 0;
        this.currentPage = 1;
        this.refreshData(true);
    },

    refreshData: async function(shouldUpdateCount) {
        this.isLoading = true;

        var query = this.generateQuery();
        console.log('GenericTableView::refreshData::query: ', query);

        query = encodeURI(query);
        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);

            var tmpData = [];
            for(var i=0; i<response.data.length; i++) {
                var item = response.data[i];
                console.log(item);

                if(this.rowPreprocessFunc) {
                    item = this.rowPreprocessFunc(item);
                }

                item.checked = false;

                tmpData.push(item);
            }

            this.data = tmpData;

            // calculate the count
            if(shouldUpdateCount) {
                var countQuery = this.generateCountQuery();
                console.log('count query: ', countQuery);
                countQuery = encodeURI(countQuery);

                url = Constants.HOST_URL + 'runSelectQuery?query=' + countQuery;
                response = await axios.get(url);
                console.log('count result ', response.data);

                this.pagination.total = response.data[0].count;
            }
        } 
        catch(err) {
            alert('Có lỗi khi tải dữ liệu.');
            console.log(err);
        }

        this.isLoading = false;
    },

    rowClicked (id) {
        console.log('row clicked ', event);
        this.$emit('row-clicked', {id: id})
    },

    rowEditClicked (id) {
        console.log('row-edit-clicked ', event);
        this.$emit('row-edit-clicked', {id: id})
    },

    rowDeleteClicked (id) {
        console.log('row-delete-clicked ', event);
        this.$emit('row-delete-clicked', {id: id})
    },

    rowPreviewClicked (id) {
        this.itemId = id;
        this.$emit('row-preview-clicked', {id: id})
        this.previewModalShow = !this.previewModalShow;
    },

    rowQuickFormClicked (id) {
        this.itemId = id;
        this.$emit('row-quickForm-clicked', {id: id})
        this.quickFormModalShow = !this.quickFormModalShow;
    },

    onUpdateFormSubmitted() {
        this.refreshData(false);
    },

    openFormGroupModal() {
        let ids = [];
        this.checkedIds = [];
        const _items = this.data;

        for (let i = 0; i < _items.length; i++) {
            if (_items[i].checked) {
                ids.push(_items[i].id);
            }
        }

        this.checkedIds = ids;

        this.modalShow = !this.modalShow;
    },

    updateGroupClicked(menuItem) {
        let ids = [];
        const _items = this.data;

        for (let i = 0; i < _items.length; i++) {
            if (_items[i].checked) {
                ids.push(_items[i].id);
            }
        }

        this.$emit('update-group-clicked', {menu_code: menuItem, ids: ids})
    },

    deleteGroupClicked() {
        let ids = [];
        const _items = this.data;

        for (let i = 0; i < _items.length; i++) {
            if (_items[i].checked) {
                ids.push(_items[i].id);
            }
        }
        
        this.$emit('delete-group-clicked', {ids: ids})
    },

    updateStar(id, isfavored) {
        this.$emit('star-clicked', {id: id, isfavored: !isfavored})
    },

    cellClicked (key, value) {
        this.$emit('cell-clicked', {key: key, value: value})
    },

    menuClicked (menuItem, id) {
        this.$emit('menu-clicked', {menu_code: menuItem, id: id})
    },

    gotoMap (coord) {
        var location = coord.replace(/\s/g, "");
        // value is the gps
        var url='https://www.google.com/maps/search/?api=1&query='+location;
        window.open(url,'_blank');
    },

    copyToClipboard (value) {
        // var tempInput = document.createElement("input");
        // tempInput.value = value;
        // document.body.appendChild(tempInput);
        // tempInput.select();
        // document.execCommand("copy");
        // document.body.removeChild(tempInput);

        var tempTextArea = document.createElement("textarea");
        tempTextArea.value = value;
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
        document.execCommand("copy");
        document.body.removeChild(tempTextArea);
    },

    
  },
  mounted () {
    setTimeout(() => {
        this.generateTableViews();
        this.refreshData(true);
        
    }, 500)
    // this.refreshData(true);
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<style scoped>
.pointer {
    cursor: pointer;
}
.text-bold {
    font-weight: bold;
}

.delete-btn {
    font-weight: bold;
    text-decoration: underline;
    font-style: italic;
    cursor: pointer;
    color: red;
}
.vbst-item {
    background: white;
}
.clickable {cursor: pointer;}

.preserve-whitespace {
    white-space: pre-wrap; /* This preserves newlines and spaces */
    word-wrap: break-word; /* Optionally, wrap long words */
}

/* Responsive table improvements */
.responsive-table {
    font-size: 0.875rem;
    width: 100%;
    overflow-x: auto;
}

.responsive-table .table {
    width: 100%;
    min-width: 1200px;
    margin-bottom: 0;
}

.responsive-table .table th {
    background-color: #343a40;
    color: white;
    font-weight: 600;
    font-size: 0.875rem;
    border: 1px solid #454d55;
    padding: 0.75rem 0.5rem;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}

.responsive-table .table td {
    border: 1px solid #dee2e6;
    font-size: 0.875rem;
    padding: 0.5rem 0.5rem;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}

/* Ensure table container doesn't overflow */
.responsive-table .table-responsive {
    border: none;
    margin: 0;
    padding: 0;
    overflow-x: auto;
}

/* Better responsive behavior for larger screens */
@media (min-width: 1200px) {
    .responsive-table .table {
        min-width: auto;
    }
    
    .responsive-table .table th,
    .responsive-table .table td {
        max-width: none;
        white-space: normal;
    }
}

@media (max-width: 768px) {
    .responsive-table {
        font-size: 0.75rem;
    }
    
    .responsive-table .table td,
    .responsive-table .table th {
        padding: 0.5rem 0.25rem;
        vertical-align: middle;
    }
    
    .responsive-table .btn-sm {
        padding: 0.2rem 0.4rem;
        font-size: 0.7rem;
    }
    
    .responsive-table .dropdown-toggle {
        padding: 0.2rem 0.4rem;
        font-size: 0.7rem;
    }
    
    /* Improve text wrapping in table cells */
    .responsive-table .table td {
        word-break: break-word;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    /* Make action buttons more compact */
    .responsive-table .card-actions {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
    
    .responsive-table .card-actions .btn {
        margin: 1px 0;
    }
}

@media (max-width: 576px) {
    .responsive-table {
        font-size: 0.7rem;
    }
    
    .responsive-table .table td,
    .responsive-table .table th {
        padding: 0.25rem 0.1rem;
    }
    
    .responsive-table .btn-sm {
        padding: 0.15rem 0.3rem;
        font-size: 0.65rem;
    }
    
    /* Hide less important columns on very small screens */
    .responsive-table .table th:nth-child(n+4),
    .responsive-table .table td:nth-child(n+4) {
        display: none;
    }
    
    /* Show only essential columns */
    .responsive-table .table th:nth-child(1),
    .responsive-table .table th:nth-child(2),
    .responsive-table .table th:nth-child(3),
    .responsive-table .table td:nth-child(1),
    .responsive-table .table td:nth-child(2),
    .responsive-table .table td:nth-child(3) {
        display: table-cell;
    }
}
</style>
